import { all, takeEvery } from 'redux-saga/effects';
import { actionTypes } from './actions';
import { saveClientContractPeriod } from './workers/saveClientContractPeriod';
import { deleteClientContractPeriod } from './workers/deleteClientContractPeriod';

export default function* rootSaga() {
  yield all([takeEvery(actionTypes.SAVE_CLIENT_CONTRACT_PERIOD, saveClientContractPeriod)]);
  yield all([takeEvery(actionTypes.DELETE_CLIENT_CONTRACT_PERIOD, deleteClientContractPeriod)]);
}
